export const CALLER_UNKNOWN = "UNKNOWN";
export const HEADER_X_CLIENT_ID = "X_CLIENT_ID";
export const HEADER_X_USER_ID = "X_USER_ID";
export const HEADER_X_REQUEST_ID = "X_REQUEST_ID";
export const HEADER_X_START_TIME = "X_START_TIME";
export const CSRF_TOKEN = "csrf";
export const USER_TOKEN_HEADER_NAME = "csrf";
export const UNAUTHORIZED_ACCESS = "Unauthorized access";
export const REGION = "region";
export const AUTHORIZATION = "Authorization";

export const COUNTRIES = {
  COUNTRY_NAME_INDIA: "INDIA",
  COUNTRY_NAME_KSA: "SAUDI ARABIA",
  COUNTRY_NAME_EGYPT: "EGYPT",
  COUNTRY_NAME_UAE: "UNITED ARAB EMIRATES",
};

export const DATE_FORMAT = "dd/MM/yyyy";
export const DATE_FORMAT_YYYY = "yyyy-MM-dd";

// REGIONS
export const REGION_NAME_LIST = {
  AE: {
    name: "United Arab Emirates",
    code: "AE",
  },
  EG: {
    name: "Egypt",
    code: "EG",
  },
  SA: {
    name: "Saudi Arabia",
    code: "SA",
  },
};
